import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/AdminCompanyManagement';

const getDetailCompanyReducer = handleActions({
    [Actions.GetDetailCompanyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailCompanyReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailCompanyReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetDetailCompany]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const editDetailCompanyReducer = handleActions({
    [Actions.EditCompanyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.EditCompanyReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload.response,
        editSuccess: true,
    }),
    [Actions.EditCompanyReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        editSuccess: false,
    }),
    [Actions.ClearEditCompany]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        editSuccess: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    editSuccess: false,
});
const deleteDetailCompanyReducer = handleActions({
    [Actions.DeleteCompanyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.DeleteCompanyReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        deleteSuccess: true,
    }),
    [Actions.DeleteCompanyReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        deleteSuccess: false,
    }),
    [Actions.ClearDeleteCompany]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        deleteSuccess: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    deleteSuccess: false,
});
const getListSeminarReducer = handleActions({
    [Actions.GetListSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListSeminarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListSeminarReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const detailSeminarReducer = handleActions({
    [Actions.GetDetailSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailSeminarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailSeminarReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearDetailSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
    [Actions.UpdateSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.UpdateSeminarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.UpdateSeminarReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});
const updateSeminarReducer = handleActions({
    [Actions.UpdateSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
        updateSeminarSuccess: false,
    }),
    [Actions.UpdateSeminarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        updateSeminarSuccess: true,
    }),
    [Actions.UpdateSeminarReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        updateSeminarSuccess: false,
    }),
    [Actions.UpdateSeminarProgess]: (state, action) => ({
        ...state,
        percent: action.payload,
    }),
    [Actions.ClearSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        percent: 0,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    updateSeminarSuccess: false,
    percent: 0,
});

const listProductReducer = handleActions({
    [Actions.GetListProductExhibitionRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListProductExhibitionReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListProductExhibitionReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetListProductExhibition]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const detailProductReducer = handleActions({
    [Actions.GetDetailProductExhibitionRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailProductExhibitionReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailProductExhibitionReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetDetailProductExhibition]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const editProductReducer = handleActions({
    [Actions.EditProductExhibitionRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.EditProductExhibitionReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.EditProductExhibitionReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearEditProductExhibition]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const deleteProductReducer = handleActions({
    [Actions.DeleteProductExhibitionRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.DeleteProductExhibitionReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        deleteSuccess: true,
    }),
    [Actions.DeleteProductExhibitionReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        deleteSuccess: false,
    }),
    [Actions.ClearDeleteProductExhibition]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        deleteSuccess: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    deleteSuccess: false,
});
const deleteSeminarReducer = handleActions({
    [Actions.callApiDeleteSeminarOfCompany]: (state) => ({
        ...state,
        isFetching: true,
        deleteSuccessSeminar: false,
    }),
    [Actions.callApiDeleteSeminarOfCompanyReceived]: (state) => ({
        ...state,
        isFetching: false,
        deleteSuccessSeminar: true,
    }),
    [Actions.callApiDeleteSeminarOfCompanyReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        deleteSuccessSeminar: false,
    }),
    [Actions.clearCallApiDeleteSeminarOfCompany]: (state) => ({
        ...state,
        isFetching: false,
        errors: {},
        deleteSuccessSeminar: false,
    }),
}, {
    isFetching: false,
    errors: {},
    deleteSuccessSeminar: false,
});

const getDetailCompanyForSideBarReducer = handleActions({
    [Actions.GetDetailCompanyForSidebarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailCompanyForSidebarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailCompanyForSidebarReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetDetailCompanyForSidebar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

export default combineReducers({
    detailCompany: getDetailCompanyReducer,
    detailSeminar: detailSeminarReducer,
    editCompany: editDetailCompanyReducer,
    listSeminar: getListSeminarReducer,
    updateSeminar: updateSeminarReducer,
    listProduct: listProductReducer,
    detailProduct: detailProductReducer,
    editProduct: editProductReducer,
    deleteProduct: deleteProductReducer,
    deleteSeminar: deleteSeminarReducer,
    deleteCompany: deleteDetailCompanyReducer,
    detailCompanyForSideBar: getDetailCompanyForSideBarReducer,
});
